import dateQuickPickTemplate from './dateQuickpick.html';

function directive() {
  return {
    restrict: 'E',
    scope: {
      type: '@',
      time: '=',
      update: '&',
      pickerDisabled: '='
    },
    template: dateQuickPickTemplate,
    controller: [
      '$scope',
      'moment',
      'timezoneService',
      ($scope, moment, timezoneService) => {
        const timezone = timezoneService.userTimezone;
        $scope.yesterday = moment.tz(timezone).add(-1, 'days').format('ddd');
        $scope.tomorrow = moment.tz(timezone).add(1, 'days').format('ddd');

        $scope.setTimeTo = (date) => {
          $scope.update({ day: date, setAsDay: true });
          $scope.activeDate = date;
        };
      }
    ],
    link($scope) {
      const scope = $scope;
      scope.$watch('time', () => {
        if (!scope.time || typeof scope.time !== 'string') scope.activeDate = null;
        else scope.activeDate = scope.time;
      });
    }
  };
}

export default function (ngModule) {
  ngModule.directive('twpDateQuickpick', directive);
}
